<template>
  <div>
    <a-modal
      title="费用分摊"
      :width="1000"
      v-model="listVisible"
      :footer="null"
      :maskClosable="false"
    >
      <a-spin :spinning="listLoading">
        <a-table
          :dataSource="apportionListRes"
          :columns="columns"
          :rowKey="record => record.id"
          :pagination="false"
        >
        </a-table>
      </a-spin>
    </a-modal>
    <a-modal
      title="编辑"
      v-model="formVisible"
      :maskClosable="false"
      :confirmLoading="formLoading"
      @ok="handleOk"
    >
      <a-spin :spinning="formLoading">
        <a-form :form="form">
          <a-form-item
            label="开始时间"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-date-picker
              :disabledDate="disabledStartDate"
              format="YYYY-MM-DD"
              v-model="startValue"
              placeholder="请选择开始时间"
              @openChange="handleStartOpenChange"
            />
          </a-form-item>
          <a-form-item
            label="结束时间"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-date-picker
              :disabledDate="disabledEndDate"
              format="YYYY-MM-DD"
              placeholder="请选择结束时间"
              v-model="endValue"
              :open="endOpen"
              @openChange="handleEndOpenChange"
            />
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { FormMixin } from '@/mixins/FormMixin'
import { apportionList, updateTransferDateRange } from '@/api/common/SxCompanyMachine'
export default {
  name: 'CostApportion',
  mixins: [FormMixin],
  data () {
    return {
      listVisible: false,
      listLoading: false,
      formVisible: false,
      formLoading: false,
      queryParam: {
        assertId: ''
      },
      apportionListRes: [],
      columns: [
        {
          title: '所在项目',
          dataIndex: 'projectIdName'
        },
        {
          title: '操作时间',
          dataIndex: 'createTime'
        },
        {
          title: '开始时间',
          dataIndex: 'startDate'
        },
        {
          title: '结束时间',
          dataIndex: 'endDate'
        },
        {
          title: '操作',
          customRender: (record) => {
            return (
              <div>
                <span>
                  <a onClick={(e) => this.edit(record.id)}>编辑</a>
                </span>
              </div>
            )
          }
        }
      ],
      form: this.$form.createForm(this),
      startValue: null,
      endValue: null,
      endOpen: false,
      updateParams: {
        id: '',
        startDate: '',
        endDate: ''
      }
    }
  },
  watch: {
    startValue (val) {
      let formatStartDate = ''
      if (val) {
        formatStartDate = moment(val).format('YYYY-MM-DD')
      }
      this.updateParams.startDate = formatStartDate
    },
    endValue (val) {
      let formatEndDate = ''
      if (val) {
        formatEndDate = moment(val).format('YYYY-MM-DD')
      }
      this.updateParams.endDate = formatEndDate
    }
  },
  methods: {
    init (id) {
      this.listVisible = true
      this.queryParam.assertId = id
      this.getApportionList(this.queryParam)
    },
    /**
     * 获取转移记录列表
     * @param params  查询参数
     */
    getApportionList (params) {
      this.listLoading = true
      apportionList(params).then((res) => {
        this.listLoading = false
        this.apportionListRes = res.data
      })
    },
    edit (id) {
      this.formVisible = true
      this.updateParams.id = id
    },
    disabledStartDate (startValue) {
      const endValue = this.endValue
      if (!startValue || !endValue) {
        return false
      }
      return startValue.valueOf() > endValue.valueOf()
    },
    disabledEndDate (endValue) {
      const startValue = this.startValue
      if (!endValue || !startValue) {
        return false
      }
      return startValue.valueOf() >= endValue.valueOf()
    },
    handleStartOpenChange (open) {
      if (!open) {
        this.endOpen = true
      }
    },
    handleEndOpenChange (open) {
      this.endOpen = open
    },
    handleOk () {
      this.formLoading = true
      updateTransferDateRange(this.updateParams).then((res) => {
        this.formLoading = false
        this.formVisible = false
        this.startValue = null
        this.endValue = null
        this.$message.success('更新成功', 1, () => {
          this.getApportionList(this.queryParam)
        })
      }).catch((err) => {
        this.formLoading = false
        this.startValue = null
        this.endValue = null
        this.$message.error(err.msg)
      })
    }
  }
}
</script>

<style scoped>
</style>
